import * as Yup from 'yup';

const MAX_UPLOAD_BYTES = 50 * 1024 * 1024; // 50 MB (TechSpec §3.4)
const EXTENSOES_VALIDAS = /\.(txt|cnab|ret|rem)$/i;

// Yup completo (LICOES §1.6 / FE-002): required + format + size + custom .test().
export const importarSchema = Yup.object().shape({
  codigoGrupoEmpresa: Yup.number()
    .typeError('Empreendimento é obrigatório')
    .required('Empreendimento é obrigatório')
    .positive('Empreendimento inválido')
    .integer('Empreendimento inválido'),
  arquivo: Yup.mixed()
    .required('Arquivo é obrigatório')
    .test('fileSize', 'Tamanho máximo permitido: 50 MB', (f) =>
      !f ? false : f.size <= MAX_UPLOAD_BYTES
    )
    .test(
      'fileType',
      'Extensões aceitas: .txt, .cnab, .ret, .rem',
      (f) => (!f ? false : EXTENSOES_VALIDAS.test(f.name))
    ),
});

export const contrapartidaSchema = Yup.object().shape({
  contaRelacionada: Yup.number()
    .typeError('Conta relacionada é obrigatória')
    .required('Conta relacionada é obrigatória')
    .positive('Conta relacionada inválida')
    .integer('Conta relacionada inválida'),
  contrapartida: Yup.number()
    .typeError('Contrapartida é obrigatória')
    .required('Contrapartida é obrigatória')
    .positive('Contrapartida inválida')
    .integer('Contrapartida inválida'),
  aplicarLote: Yup.boolean(),
  centroCusto: Yup.number()
    .nullable()
    .typeError('Centro de custo inválido')
    .positive('Centro de custo inválido')
    .integer('Centro de custo inválido'),
});
